/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartSummary',[
    'jquery',
    'global/all',
    './CartManager'
], function ($, Roc, CartManager) {
    'use strict';

    var baseApiUrl,
        checkoutUrl,
        cartFlyoutTmpSelector,
        showAddToCartModal,
        $cartTotalItems;

    function reloadSummary() {
        Roc.Logger.debug('Loading Cart Summary...');
        CartManager.getSummary();
    }

    function showRecentCart(data) {
        data.checkoutUrl = checkoutUrl;

        Roc.UI.template(cartFlyoutTmpSelector, data).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
        });
    };

    function itemAddedEvt(data) {
        if (data && data.success) {
            reloadSummary();
            if (showAddToCartModal) {
                showRecentCart(data);
            }
        }
    }

    function itemUpdated(data) {
        if (data && data.details) {
            reloadSummary();
        }
    }

    function updateQtyOnPage(qty) {
        $cartTotalItems.html('<span class="text">My Cart</span> (' + qty + ')');
    }

    function updateQty(xhr) {
        var summary = xhr.responseJSON || {};
        if (summary.items) {
            var totalItems = parseInt(summary.items);
            if (!isNaN(totalItems)) {
                updateQtyOnPage(totalItems);
                return;
            }
        }
        updateQtyOnPage(0);
    }

    function updateQtyFromFullCart(cart) {
        if (cart !== undefined && cart !== null && cart.items && _.isArray(cart.items)) {
            var summedQty = 0;
            _.each(cart.items, function(item) {
                summedQty += item.quantity;
            });
            updateQtyOnPage(summedQty);
        }
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedEvt);
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_ITEM, itemUpdated);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_ITEM, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, itemAddedEvt); 
        Roc.EventManager.bind(Roc.Events.cart.GET_SUMMARY, updateQty);
        Roc.EventManager.bind(Roc.Events.cart.CART_LOADED, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.RE_ORDER, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, updateQtyFromFullCart);
    }

    function init(options) {
        baseApiUrl = options.baseApiUrl;
        cartFlyoutTmpSelector = options.cartFlyoutTmpSelector;
        $cartTotalItems = $('#spanCartTotal');
        checkoutUrl = options.checkoutUrl;
        showAddToCartModal = options.showAddToCartModal;
        bindEvents();

        reloadSummary();
    }

    var CartSummary = { init: init };

    Roc.Logger.debug('CartSummary.js Loaded:', CartSummary);

    return CartSummary;
});
